import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { autocompleteClasses } from '@mui/material';
import * as React from 'react';
import { FlexBox } from '../../box';
import { Checkbox } from '../../checkbox';
import { Chip, ChipGroup } from '../../chip';
import { Divider } from '../../divider';
import { IconCheckCircle } from '../../icon';
import { Typography } from '../../typography';
export const FacilityMenuItem = (props) => {
    const { disabledSelection = false, option: { tags = [], name, facilityName, prefix }, selected = false, multiple, accountNumber } = props;
    const liProps = disabledSelection
        ? omitProps(props.liProps, [
            'onTouchStart',
            'onMouseMove',
            'onClick',
            'aria-selected'
        ])
        : props.liProps;
    const className = liProps.className?.replace(autocompleteClasses.option, '');
    return (_jsxs(FlexBox, { role: "option", ...liProps, className: className, hAlign: "flex-start", overflow: "hidden", padding: 0, width: "100%", height: "100%", stack: true, stretch: true, sx: {
            cursor: multiple ? 'default' : 'pointer',
            '&.Mui-focused': disabledSelection
                ? {}
                : {
                    backgroundColor: (theme) => theme.palette.action.hover
                }
        }, children: [_jsxs(FlexBox, { vAlign: "center", padding: [1, 2], gap: 1, width: "100%", stretch: true, children: [multiple && _jsx(Checkbox, { checked: selected }), _jsxs(FlexBox, { vAlign: "center", autoShrink: true, gap: 2, children: [!multiple && !disabledSelection && (_jsx(FlexBox, { vAlign: "center", visibility: selected ? 'visible' : 'hidden', children: _jsx(IconCheckCircle, { color: "components.facility.contrast.icon" }) })), _jsxs(FlexBox, { vAlign: "center", gap: 0.75, autoShrink: true, stack: true, children: [_jsxs(FlexBox, { vAlign: "center", autoShrink: true, stack: true, children: [_jsxs(FlexBox, { gap: 0.25, children: [_jsx(Typography, { variant: "subtitle2", children: name ?? facilityName }), prefix && (_jsx(Typography, { children: `(${prefix})` }))] }), selected && accountNumber && (_jsxs(Typography, { color: "text.secondary", variant: "caption", children: [accountNumber.title, ": ", accountNumber.value] }))] }), tags.length ? (_jsx(ChipGroup, { minHeight: 24, children: tags.map(({ name }) => (_jsx(Chip, { label: name }, name))) })) : null] }), props.children] })] }), _jsx(Divider, { orientation: "horizontal" })] }));
};
function omitProps(obj, keys) {
    const copy = { ...obj };
    keys.forEach((key) => {
        delete copy[key];
    });
    return copy;
}
